import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/react-query";
import { clearChunkReloadFlag } from "@/lib/lazy-with-retry";
import App from "./App";
import "./index.css";
import "./i18n";
// Weather utilities removed - weather is now fetched on-demand when creating tickets/adding photos

// Clear the chunk-reload flag on successful page load so that future
// stale-chunk errors (after the next deployment) get a fresh reload attempt.
clearChunkReloadFlag();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);